import { downloadFileApi, getAnalyticsDataApi, getVulnerabilityDetailsApi } from "../../api/analytics/analyticsApi";
import Types from "../types";
import { setGlobalLoader } from "./commonAction";

export const getAnalyticsData = (payload) => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        dispatch(getVulnerabilityDetails(payload))
        const result = await getAnalyticsDataApi(payload)
        dispatch({
            type: Types.COST_AND_SECURITY,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}

export const getVulnerabilityDetails = (payload) => {
    return async function (dispatch) {
        const result = await getVulnerabilityDetailsApi(payload)
        dispatch({
            type: Types.VULNERABILITY_DETAILS,
            payload: result?.vulnDetail
        });
    }
}

export const downloadFile = (payload, callback) => {
    return async function () {
        const result = await downloadFileApi(payload);
        const url = URL.createObjectURL(new Blob([result]))
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `vulnerabilities.csv`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        callback && callback()
    }
}

